import { gql } from 'apollo-boost'

export const UPDATE_NOTE = gql`
  mutation updateMemberNote($data: updateMemberNote) {
    updateMemberNote( data: $data)
  }
`


